import {NgModule, Optional, SkipSelf} from '@angular/core';
import {throwIfAlreadyLoaded} from './guard/module-import.guard';
import {AuthGuard} from '@core/guard/auth.guard';
import {IdService} from '@core/service/uuid.service';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AccessMenuGuard} from '@core/guard/access-menu.guard';
import {LoginGuard} from '@core/guard/login.guard';


@NgModule({
  declarations: [
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
  ],
  exports: [
    // Core Module không dùng để export bất kỳ thứ gì
  ],
  providers: [
    AuthGuard,
    AccessMenuGuard,
    LoginGuard,
    IdService,
  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}
